import { FC } from 'react';
import { IEntityContentField } from '../../../../lib/interfaces/Common';
import ContentRenderer from '../../Content/ContentRenderer';
import ContentTitleSimple from '../../../Simple/ContentTitle/ContentTitleSimple';

type ContentBlockProps = {
	field: IEntityContentField;
};

const ContentBlock: FC<ContentBlockProps> = ({ field }) => {
	const title = field.options?.label;
	return (
		<div className="ContentBlock">
			{title && <ContentTitleSimple title={title} id={field.id} />}
			<ContentRenderer html={field.content} key={field.name} />
		</div>
	);
};

export default ContentBlock;
